import AxiosInstance from "./api";

export const JointVentureInvestmentDetailedRecordService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/joint-venture-investment-detailed-record/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/joint-venture-investment-detailed-record/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/joint-venture-investment-detailed-record", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/joint-venture-investment-detailed-record/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/joint-venture-investment-detailed-record/" + id);
  },
};
